import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ToolsComponent} from '../tools/tools.component';
import {SignListComponent} from '../sign-list/sign-list.component';
import {state, style, transition, trigger, animate} from '@angular/animations';
import {PropertiesComponent} from '../properties/properties.component';
import {DocumentListComponent} from '../document-list/document-list.component';
import {AttachFileComponent} from '../../attach-file/attach-file.component';
import { Form, TaskAttribute } from '../../create-task/create-task.type';

@Component({
   selector: 'app-left-panel',
   templateUrl: './left-panel.component.html',
   styleUrls: ['./left-panel.component.css'],
   animations: [
      trigger('visibilityChanged', [
         state('shown', style({opacity: 1, zIndex: 2})),
         state('hidden', style({opacity: 0, zIndex: 0})),
         transition('shown => hidden', animate('600ms')),
         transition('hidden => shown', animate('300ms')),
      ])
   ]
})
export class LeftPanelComponent{
   public isHideType = false;
   public isHideSigner = true;
   public selectedTab = 0;
   @Input() currentActiveIndex: number;
   @Input() isAtt: any;
   @Input() isFormName: boolean;
   public disableButtonByAttach = false;
   @Input() typeName: any;
   @Input() mimType;
   @Input() isShowAttachFile: boolean;
   @Input() taskAttribute: TaskAttribute;
   @Input() signMenuClick: any;
   @Input() signMenuDrag: any;
   @Input() isHideDeleteBtn: any;
   @Input() isHideRequire: any;
   @Input() isHideProperties: any;
   @Input() colors: any;
   @Input() pageType: any;
   @Input() positionType: any;
   @Input() chkName: boolean;
   @Input() chkDate: boolean;
   @Input() chkApplyAll: boolean;
   @Input() isDisabledChk: boolean;
   @Input() certId: any;
   @Input() disableButtonSign: boolean;
   @Input() checkButton: boolean;
   @Input() show = true;
   @Input() viewMode = false;
   @Input() fieldType: any;
   @Input() fontDetail: any;
   @Input() fieldName: any;
   @Input() selectedSignerList: any;
   @Input() haveSignField: boolean;
   @Input() isShowSignTool: boolean = false;
   @Output() listClick = new EventEmitter<{
      index: number;
      docId?: any;
      docName?: any;
      formName?: string;
      form?: Form;
   }>();
   @Output() updatefile1 = new EventEmitter<any>();
   @Output() waitActionHandle = new EventEmitter<any>();
   @Output() form = new EventEmitter<any>();
   @Output() signerChange = new EventEmitter<any>();
   @Output() signerField = new EventEmitter<any>();
   @Output() clickDelete = new EventEmitter<any>();
   @Output() selectPositionTypeChange = new EventEmitter<any>();
   @Output() selectPageTypeChange = new EventEmitter<any>();
   @Output() menuClick = new EventEmitter<any>();
   @Output() pageListClick = new EventEmitter<any>();
   @Output() positionSignClick = new EventEmitter<any>();
   @Output() setUpdateSignatureEvent = new EventEmitter<any>();
   @Output() setUpdateInitialEvent = new EventEmitter<any>();
   @Output() checkBoxChange = new EventEmitter<any>();
   @Output() selectCertChange = new EventEmitter<any>();
   @Output() selectFileuploadChange = new EventEmitter<any>();
   @Output() fontDetailTypeChange = new EventEmitter<any>();
   @Output() setSigner = new EventEmitter<any>();
   public hasSignature: boolean;
   public hasInitial: boolean;
   imageSignatureOriginal: any;
   imageInitOriginal: any;
   public profile: any;
   visiblityState = false;

   @ViewChild(ToolsComponent) toolsComp: ToolsComponent;
   @ViewChild(AttachFileComponent) attachComp: AttachFileComponent;
   @ViewChild(SignListComponent) signListComp: SignListComponent;
   @ViewChild(PropertiesComponent, { static: true }) propertiesComp: PropertiesComponent;
   @ViewChild(DocumentListComponent, { static: true }) docListComp: DocumentListComponent;
   @ViewChild('scrollElem', { static: false }) scrollElem: ElementRef;

   constructor() {
      // This is intentional.z
   }

   scrollDown(): void {
      this.scrollElem?.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
   }

   onListClick(object: {
      index: number;
      docId?: any;
      docName?: any;
      formName?: string;
      form?: Form;
   }) {
      this.disableButtonByAttach = false;
      if (this.attachComp) {
         this.attachComp.setListDocSelect();
      }
      this.listClick.emit(object);
      this.form.emit(undefined);
   }

   onListClickAttachFile(object) {
      this.disableButtonByAttach = false;
      this.attachComp.listDoc[0] = '';
      this.listClick.emit(object);
      this.form.emit(undefined);
   }

   onSignerChange($event) {
      this.signerChange.emit($event);
   }

   toggle(type: string) {
      if (type === 'add') {
         this.visiblityState = false;
      } else {
         this.visiblityState = true;
      }
   }

   onHideSigner($event) {
      this.isHideSigner = $event;
   }

   onClickDelete() {
      this.clickDelete.emit({fieldType: this.fieldType});
   }

   onSelectPositionTypeChange(value) {
      this.selectPositionTypeChange.emit(value);
   }

   onSelectPageTypeChange(value) {
      this.selectPageTypeChange.emit(value);
   }

   onCheckboxChange(value) {
      this.checkBoxChange.emit(value);
   }

   onSelectCertChange(value) {
      this.selectCertChange.emit(value);
   }

   onSelectFileuploadChange(value){
      this.selectFileuploadChange.emit(value);
   }
   onSelectedChange($event) {
      this.selectedTab = $event;
      if (this.selectedTab === 0 || this.selectedTab === 2) {
         if (this.toolsComp) {
            this.toolsComp.isExpanded = false;
         }
      } else {
         if (this.toolsComp) {
            this.toolsComp.isExpanded = true;
         }
      }
      this.menuClick.emit(0);
   }

   onPageListClick(pageNo) {
      this.pageListClick.emit(pageNo);
   }

   onPositionSignClick($event: Event) {
      this.positionSignClick.emit($event);
   }

   setUpdateSignature(event) {
      this.setUpdateSignatureEvent.emit(event);
   }
   setUpdateInclude(event) {
      const val = {
         'chkName': false,
         'chkDate': false,
         'chkApplyAll': false
      };
      this.onCheckboxChange(val);
   }
   setUpdateInitial(event) {
      this.setUpdateInitialEvent.emit(event);
   }
   updatefile(value) {
      this.updatefile1.emit(value);
   }
   waitAction(value) {
      this.waitActionHandle.emit(value);
   }

   onFontDetailTypeChange($event) {
      this.fontDetailTypeChange.emit($event);
   }

   onSignerField(event) {
      this.signerField.emit({data: event, fieldName: this.fieldName});
   }

   setSignerSelectedList(data: Array<any>) {
      this.selectedSignerList = data;
   }

   onSetSigner() {
      this.setSigner.emit();
   }
}
